angular.module("avlib").directive("infoBlock", function(){
	return {
		template: require("!html-loader!./InfoBlockTemplate.html"),
		restrict: "E",
		transclude: true,
		scope: {
			msg: '@',
			type: '@?',
			typeModel: '=?',
		},
 		link: function(scope, element, attrs, ctrl){
			if (!attrs.type) {
				attrs.type = 'info';
			}
			if (!attrs.typeModel){
				scope.typeModel = attrs.type;
			}
	 	},		
	};
});
